import React from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Typography,
} from "@material-tailwind/react";

export default function DeleteSurveyDialog({
    show,
    handleClose,
    handleDelete,
}) {
    const handleDialogClose = () => {
        handleClose();
    };
    return (
        <Dialog open={show} handler={handleDialogClose} className="dialog">
            <DialogHeader className="dialog__header">
                <Typography variant="h2">Remove Survey?</Typography>
            </DialogHeader>

            <DialogBody className="dialog__body">
                <div className="dialog__section">
                    <Typography variant="paragraph">
                        Are you sure you want to do this? This will permanently
                        remove the survey from your account.
                    </Typography>
                </div>
            </DialogBody>

            <DialogFooter className="dialog__footer">
                <Button
                    type="button"
                    className="btn btn--secondary"
                    onClick={handleDialogClose}
                >
                    Cancel
                </Button>
                <Button
                    type="submit"
                    className="btn btn--danger"
                    onClick={handleDelete}
                >
                    Remove
                </Button>
            </DialogFooter>
        </Dialog>
    );
}
